import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Ending, Language } from '@enums';
import { i18n } from '@localization';
/**
 * Endings helper.
 *
 * @author Mikhail Siutsou
 * @function endings
 * @category helpers
 * @param {number} value value.
 * @param {Ending} type ending type.
 * @return {string | undefined} type ending type.
 */

var getEnding = function getEnding(value) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ending.User;
  var endingsValues = [];

  switch (type) {
    case Ending.User:
      {
        endingsValues = [i18n.t('common.endings.users.user'), i18n.t('common.endings.users.users'), i18n.t('common.endings.users.users')];
        break;
      }

    case Ending.Group:
      {
        endingsValues = [i18n.t('common.endings.groups.group'), i18n.t('common.endings.groups.groups'), i18n.t('common.endings.groups.groups')];
        break;
      }

    case Ending.Organization:
      {
        endingsValues = [i18n.t('common.endings.organizations.organization'), i18n.t('common.endings.organizations.organizations'), i18n.t('common.endings.organizations.organizations')];
        break;
      }

    default:
      {
        endingsValues = ['', '', ''];
      }
  }

  var ending = '';
  value %= 100;

  if (i18n.language === Language.En) {
    if (value === 1) {
      var _endingsValues = endingsValues;

      var _endingsValues2 = _slicedToArray(_endingsValues, 1);

      ending = _endingsValues2[0];
    } else {
      var _endingsValues3 = endingsValues;

      var _endingsValues4 = _slicedToArray(_endingsValues3, 2);

      ending = _endingsValues4[1];
    }
  } else if (value >= 11 && value <= 19) {
    var _endingsValues5 = endingsValues;

    var _endingsValues6 = _slicedToArray(_endingsValues5, 3);

    ending = _endingsValues6[2];
  } else {
    var i = value % 10;

    switch (i) {
      case 1:
        var _endingsValues7 = endingsValues;

        var _endingsValues8 = _slicedToArray(_endingsValues7, 1);

        ending = _endingsValues8[0];
        break;

      case 2:
      case 3:
      case 4:
        var _endingsValues9 = endingsValues;

        var _endingsValues10 = _slicedToArray(_endingsValues9, 2);

        ending = _endingsValues10[1];
        break;

      default:
        var _endingsValues11 = endingsValues;

        var _endingsValues12 = _slicedToArray(_endingsValues11, 3);

        ending = _endingsValues12[2];
    }
  }

  return ending;
};

export { getEnding };